import React, { useState, useEffect } from "react";
import { AuthService, TraderUnitService } from "../../../services";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { routes } from "../../../constants/routes";
import { Button, Table } from "react-bootstrap";
import { injectModels } from "../../../redux/injectModels";
import { handleConsoleError } from "../../../utils/common-methods";
import { toast } from "react-toastify";

const TraderUnitList = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getTraderUnitData();
  }, []);

  //get
  const getTraderUnitData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await TraderUnitService.getTraderUnitListByTraderId(
          loginUser?.id
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (id, name) => {
    try {
      TraderUnitService.setSelectedTraderUnit({ id: id, name: name });
      navigate(routes.EDIT_TRADER_UNIT.replace(":unitId", id));
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  //****** Add New Data *********/
  const handleCreateShopFront = async (e) => {
    try {
      navigate(routes.CREATE_TRADER_UNIT);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="verifier-buttton">
            <Button onClick={handleCreateShopFront}>Add Unit</Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Unit Name</th>
                  <th>Business Type</th>
                  <th>Contact Person</th>
                  <th>Contact Number</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.unitName}</td>
                          <td>{item?.businessType}</td>
                          <td>{item?.contactPerson}</td>
                          <td>{item?.contactNumber}</td>
                          <td>
                            {item?.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id, item?.unitName);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["auth", "application"])(TraderUnitList);
